module.exports = __webpack_public_path__ + "static/relationship-course-image-d186efb68b05a97fca005e14a8edd6f1.jpg";